
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1598928653013",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3234",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 576a32 32 0 0 1-22.72-9.28l-192-192a32 32 0 0 1 45.44-45.44l192 192a32 32 0 0 1 0 45.44A32 32 0 0 1 512 576zM256 861.76a32 32 0 0 1-21.76-8.64l21.76-23.36-23.04 22.08a32 32 0 1 1 40.64-48.64l3.52 2.88A32 32 0 0 1 256 861.76z m521.6-7.68a32 32 0 0 1-23.36-9.92 32 32 0 0 1 0-45.12A32 32 0 0 1 800 800a32 32 0 0 1 0 44.16l-2.24 2.24a32 32 0 0 1-20.8 7.68z m-602.56-96a32 32 0 0 1-28.16-16.96v-1.92a32 32 0 0 1 12.16-43.52 32 32 0 0 1 43.52 11.84l1.92 3.52a32 32 0 0 1-13.12 43.52 32 32 0 0 1-16.96 4.48z m680.32-9.6a32 32 0 0 1-28.8-44.48 32 32 0 0 1 43.2-16 32 32 0 0 1 15.36 41.92l-2.24 4.16a32 32 0 0 1-28.16 15.36zM132.48 635.52a32 32 0 0 1-32-27.2l32-4.8-32 2.56a32 32 0 0 1 64-11.52v4.16a32 32 0 0 1-26.88 36.48z m760.64-11.2h-3.84a32 32 0 0 1-28.16-35.52v-3.2a32 32 0 1 1 64 7.36v3.2a32 32 0 0 1-32 28.16zM134.4 504h-5.12a32 32 0 0 1-26.24-35.84v-4.16a32 32 0 1 1 64 13.12 32 32 0 0 1-32.64 26.88z m752.32-10.56a32 32 0 0 1-32-24 32 32 0 0 1 23.36-40 32 32 0 0 1 38.4 22.08v2.24a32 32 0 0 1-20.48 38.72z m-706.88-112a29.76 29.76 0 0 1-14.72-3.84 32 32 0 0 1-12.8-42.56l1.92-3.52a32 32 0 1 1 55.04 32 34.24 34.24 0 0 1-29.44 17.92z m658.24-8.32a32 32 0 0 1-26.56-14.08l-2.24-3.84a32 32 0 0 1 54.4-32l-27.2 16.96 27.52-16.96a32 32 0 0 1-8.64 44.48 32 32 0 0 1-17.28 5.44zM264.96 281.28a32 32 0 0 1-24-10.88 32 32 0 0 1 2.56-44.16L245.76 224A32 32 0 1 1 288 273.28a34.56 34.56 0 0 1-23.04 8z m486.4-5.76a32 32 0 0 1-19.84-6.72l-2.24-1.92A32 32 0 1 1 768 216.32l2.56 1.92a32 32 0 0 1-19.52 57.28zM376.64 216.64a32 32 0 0 1-11.2-62.08h2.88a32 32 0 1 1 22.4 59.84h-2.88a35.84 35.84 0 0 1-11.2 2.24z m260.16-3.84a33.92 33.92 0 0 1-9.92-1.6h-3.2a32 32 0 1 1 20.16-60.48h1.92A32 32 0 0 1 666.56 192a32 32 0 0 1-29.76 20.8z m-128-20.8a32 32 0 0 1-32-32 32 32 0 0 1 29.76-32h2.24a32 32 0 0 1 32 32 32 32 0 0 1-32 32z",
        "fill": "#fff",
        "p-id": "3235"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M768 905.28a32 32 0 0 1-25.28-12.48 32 32 0 0 1 5.76-44.8 384 384 0 1 0-473.92-3.52A32 32 0 1 1 232.96 896a448 448 0 1 1 552.96 3.84 32 32 0 0 1-17.92 5.44z",
        "p-id": "3236"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 544m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
        "p-id": "3237"
      }
    }
  ]
})
    }
  